import { render, staticRenderFns } from "./SingleContactImport.vue?vue&type=template&id=21669242&scoped=true"
import script from "./SingleContactImport.vue?vue&type=script&lang=js"
export * from "./SingleContactImport.vue?vue&type=script&lang=js"
import style0 from "./SingleContactImport.vue?vue&type=style&index=0&id=21669242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21669242",
  null
  
)

export default component.exports